export default __webpack_public_path__ + "static/media/volume.3fc9bddf.svg";